import { render, staticRenderFns } from "./MarketingMaterial.vue?vue&type=template&id=d6660576&"
import script from "./MarketingMaterial.vue?vue&type=script&lang=js&"
export * from "./MarketingMaterial.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMaterial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports